<template>
    <div id="app">
        <nav>
            <div class="wrapper">
                <div class="logo">我的生活展示</div>
                <!-- <a href="/">首页</a>
                <a href="/life">生活</a>
                <a href="/log">日记</a>
                <a href="/msg">留言</a>
                <a href="javascript:" @click="$router.push('/site')">站点</a> -->
                <!-- <v-search></v-search> -->
            </div>
        </nav>
        <router-view />
        <fr-footer></fr-footer>
    </div>
</template>
<script>
import vSearch from './components/v-search';
import frFooter from './components/fr-footer';
export default {
    components: {
        vSearch,
        frFooter
    },
    data() {
        return {};
    }
};
</script>
<style lang="less">
@import '../less/_var';
#app {
    background-color: var(--background-color);
    height: auto;
    min-height: 100%;
    color: var(--front-color);
    font-size: 16px;
}
.logo{
    font-size: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
}
nav {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--header-height);
    line-height: var(--header-height);
    border-bottom: 1px solid var(--border-color);
    z-index: 100;
    background-color: var(--box-color-op80);
    backdrop-filter: saturate(180%) blur(10px);
    a {
        padding: 0 20px;
        margin-right: 20px;
        &:hover{
            text-decoration: underline;
        }
    }
}
</style>
